module.exports = __webpack_public_path__ + "static/media/tr.81546c1b.svg";